"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Badge = _interopRequireDefault(require("../Badge"));
var _DataList = _interopRequireWildcard(require("./DataList/DataList"));
var _SortableDataListItem = _interopRequireDefault(require("./SortableDataListItem"));
var _sortReducer = _interopRequireWildcard(require("./sortReducer"));
var _utils = require("./utils");
var _hooksTs = require("@gogame/hooks-ts");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["index", "key", "selected", "value"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var defaultRenderOption = function defaultRenderOption(_option, _ref) {
  var label = _ref.label,
    secondaryLabel = _ref.secondaryLabel,
    labelText = _ref.labelText,
    secondaryLabelText = _ref.secondaryLabelText,
    style = _ref.style,
    key = _ref.key,
    index = _ref.index,
    className = _ref.className,
    checkbox = _ref.checkbox,
    selected = _ref.selected,
    onClick = _ref.onClick,
    ghosted = _ref.ghosted,
    reordered = _ref.reordered,
    secondaryAction = _ref.secondaryAction,
    icon = _ref.icon,
    divider = _ref.divider,
    scrollDivider = _ref.scrollDivider,
    actionCount = _ref.actionCount,
    button = _ref.button,
    disableGutters = _ref.disableGutters,
    provided = _ref.provided,
    snapshot = _ref.snapshot,
    primaryTypographyProps = _ref.primaryTypographyProps,
    secondaryActionProps = _ref.secondaryActionProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SortableDataListItem["default"], {
    label: label,
    secondaryLabel: secondaryLabel,
    style: style,
    index: index,
    className: className,
    checkbox: checkbox,
    selected: selected,
    ghosted: ghosted,
    reordered: reordered,
    onClick: onClick,
    secondaryAction: secondaryAction,
    icon: icon,
    divider: divider,
    scrollDivider: scrollDivider,
    actionCount: actionCount,
    button: button,
    disableGutters: disableGutters,
    provided: provided,
    snapshot: snapshot,
    labelText: labelText,
    secondaryLabelText: secondaryLabelText,
    primaryTypographyProps: primaryTypographyProps,
    secondaryActionProps: secondaryActionProps
  }, key);
};
var SortableDataList = function SortableDataList(_ref2) {
  var options = _ref2.options,
    _ref2$renderOption = _ref2.renderOption,
    renderOption = _ref2$renderOption === void 0 ? defaultRenderOption : _ref2$renderOption,
    _ref2$getOptionLabel = _ref2.getOptionLabel,
    getOptionLabel = _ref2$getOptionLabel === void 0 ? _DataList.defaultGetOptionLabel : _ref2$getOptionLabel,
    _ref2$getOptionSecond = _ref2.getOptionSecondaryLabel,
    getOptionSecondaryLabel = _ref2$getOptionSecond === void 0 ? _DataList.defaultGetOptionSecondaryLabel : _ref2$getOptionSecond,
    getOptionValue = _ref2.getOptionValue,
    rowHeight = _ref2.rowHeight,
    className = _ref2.className,
    onScroll = _ref2.onScroll,
    divider = _ref2.divider,
    checkbox = _ref2.checkbox,
    onItemClick = _ref2.onItemClick,
    secondaryAction = _ref2.secondaryAction,
    icon = _ref2.icon,
    button = _ref2.button,
    disableGutters = _ref2.disableGutters,
    actionCount = _ref2.actionCount,
    onReorder = _ref2.onReorder,
    getOptionLabelText = _ref2.getOptionLabelText,
    getOptionSecondaryLabelText = _ref2.getOptionSecondaryLabelText,
    primaryTypographyProps = _ref2.primaryTypographyProps,
    secondaryActionProps = _ref2.secondaryActionProps;
  var selectableListActionsRef = (0, _react.useRef)(null);
  var prevOptions = (0, _hooksTs.usePrevious)(options);
  var _useReducer = (0, _react.useReducer)(_sortReducer["default"], {
      selectedOptionIds: [],
      reorderedOptionIds: [],
      draggingOptionId: null
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    selectedOptionIds = _useReducer2$.selectedOptionIds,
    draggingOptionId = _useReducer2$.draggingOptionId,
    reorderedOptionIds = _useReducer2$.reorderedOptionIds,
    dispatch = _useReducer2[1];
  var handleDragStart = (0, _react.useCallback)(function (start) {
    var option = selectableListActionsRef.current.getGroupedOptionByIndex(start.source.index);
    dispatch({
      type: _sortReducer.DRAG_START,
      payload: getOptionValue(option)
    });
  }, []);
  var handleDragEnd = (0, _react.useCallback)(function (_ref3) {
    var destination = _ref3.destination,
      source = _ref3.source,
      reason = _ref3.reason;
    if (destination && reason !== 'CANCEL') {
      var _selectableListAction = selectableListActionsRef.current,
        getGroupedOptions = _selectableListAction.getGroupedOptions,
        getGroupedOptionByValue = _selectableListAction.getGroupedOptionByValue;
      onReorder((0, _utils.mutliDragAwareReorder)({
        options: getGroupedOptions(),
        destination: destination,
        source: source,
        selectedOptions: selectedOptionIds.map(getGroupedOptionByValue)
      }));
    }
    dispatch({
      type: _sortReducer.DRAG_END,
      payload: null
    });
  }, [selectedOptionIds]);
  (0, _react.useEffect)(function () {
    dispatch({
      type: _sortReducer.SELECT,
      payload: []
    });
  }, [options]);
  var handleItemClick = (0, _react.useCallback)(function (e, value) {
    var newSelectedOptionIds = selectedOptionIds.includes(value) ? selectedOptionIds.filter(function (v) {
      return v !== value;
    }) : [].concat(_toConsumableArray(selectedOptionIds), [value]);
    dispatch({
      type: _sortReducer.SELECT,
      payload: newSelectedOptionIds
    });
    onItemClick === null || onItemClick === void 0 || onItemClick(e, value);
  }, [selectedOptionIds]);
  var isSelected = (0, _react.useCallback)(function (_option, _ref4) {
    var value = _ref4.value;
    return selectedOptionIds.includes(value);
  }, [selectedOptionIds]);
  var scrollToIndex = (0, _react.useMemo)(function () {
    return prevOptions && options.length > prevOptions.length ? options.length - 1 : undefined;
  }, [options]);
  var renderListOption = function renderListOption(option, _ref5) {
    var index = _ref5.index,
      key = _ref5.key,
      selected = _ref5.selected,
      value = _ref5.value,
      optionProps = _objectWithoutProperties(_ref5, _excluded);
    var id = "".concat(value);
    var ghosted = selected && draggingOptionId && draggingOptionId !== id;
    var reordered = reorderedOptionIds.includes(id);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.Draggable, {
      draggableId: "".concat(index),
      index: index,
      children: function children(provided, snapshot) {
        return renderOption(option, _objectSpread({
          provided: provided,
          snapshot: snapshot,
          index: index,
          key: key,
          value: value,
          selected: selected,
          ghosted: ghosted,
          reordered: reordered,
          secondaryActionProps: secondaryActionProps
        }, optionProps));
      }
    }, key);
  };
  var renderClone = function renderClone(provided, snapshot, rubric) {
    var option = selectableListActionsRef.current.getGroupedOptionByIndex(rubric.source.index);
    var label = getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(option);
    var secondaryLabel = getOptionSecondaryLabel === null || getOptionSecondaryLabel === void 0 ? void 0 : getOptionSecondaryLabel(option);
    return renderOption(option, {
      provided: provided,
      snapshot: snapshot,
      label: label,
      secondaryLabel: secondaryLabel,
      secondaryAction: selectedOptionIds.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge["default"], {
        badgeContent: selectedOptionIds.length,
        color: 'error'
      }) : null
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd,
    onDragStart: handleDragStart,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.Droppable, {
      droppableId: 'droppable',
      mode: 'virtual',
      renderClone: renderClone,
      children: function children(droppableProvided) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataList["default"], {
          ref: function ref(_ref6) {
            // react-virtualized has no way to get the list's ref that I can so
            // So we use the `ReactDOM.findDOMNode(ref)` escape hatch to get the ref
            if (_ref6) {
              // eslint-disable-next-line react/no-find-dom-node
              var whatHasMyLifeComeTo = _reactDom["default"].findDOMNode(_ref6);
              if (whatHasMyLifeComeTo instanceof HTMLElement) {
                droppableProvided.innerRef(whatHasMyLifeComeTo);
              }
            }
          },
          options: options,
          renderOption: renderListOption,
          getOptionLabel: getOptionLabel,
          getOptionSecondaryLabel: getOptionSecondaryLabel,
          getOptionLabelText: getOptionLabelText,
          getOptionSecondaryLabelText: getOptionSecondaryLabelText,
          getOptionValue: getOptionValue,
          isSelected: isSelected,
          rowHeight: rowHeight,
          className: className,
          scrollToIndex: scrollToIndex,
          onScroll: onScroll,
          divider: divider,
          checkbox: checkbox,
          onItemClick: handleItemClick,
          secondaryAction: secondaryAction,
          icon: icon,
          button: button,
          actionCount: actionCount,
          disableGutters: disableGutters,
          actions: selectableListActionsRef,
          primaryTypographyProps: primaryTypographyProps
        });
      }
    })
  });
};
var _default = exports["default"] = SortableDataList;